<template>
    <div style="background-color:rgb(248, 248, 248);margin:0px 0px;">
        <div class="row align-items-center no-gutters settings-header">
            <div class="col-12">
                <a href="#" class="settings-header">
                    <i class="bi bi-plus-square" style="float:right;"></i><i class="bi bi-sliders"></i> <strong> {{title}}</strong>
                </a>
                <hr style="margin:0px;"/>
            </div>
        </div> 
        <div style="padding:8px;font-size:16px;">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Settings',
    components: {},
    props: ['location', 'factsheet', 'loaded', 'title', 'collapsed', 'collapsable'],
    data() {
        return {

        }
    },
    created() {
    },
    computed: {
    },
    mounted() {
    }
}
</script>

<style scoped>
    a.settings-header {
        color:#666;
        background-color:#f5f5f5;
        display:block;
        padding:6px 8px;
        font-size:16px;
        pointer-events: none;   
    }
    a.settings-header:hover {
        background-color:#eeeeee;
    }
    div.settings-header i.bi-plus-square {
        display:none;
    }

</style>